module.exports = __webpack_public_path__ + "img/mintNetworkLogoETH.ef80bb24.svg";